/* Italian locals for flatpickr */
var flatpickr = flatpickr || { l10ns: {} };
flatpickr.l10ns.it = {};

flatpickr.l10ns.it.weekdays = {
	shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
	longhand: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"]
};

flatpickr.l10ns.it.months = {
	shorthand: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
	longhand: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
};

flatpickr.l10ns.it.firstDayOfWeek = 1;

flatpickr.l10ns.it.ordinal = "°";

flatpickr.l10ns.it.weekAbbreviation = "Se";

flatpickr.l10ns.it.scrollTitle = "Scrolla per aumentare";

flatpickr.l10ns.it.toggleTitle = "Clicca per cambiare";

if (typeof module !== "undefined") module.exports = flatpickr.l10ns;


//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/it.js
// module id = 15
// module chunks = 0